
import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Name extends Vue {
  @Prop()
  private visible: any;
  private get ifShow() {
    return this.visible;
  }
  private set ifShow(val: any) {
    this.$emit("updateAgree", val);
  }
}
